module.exports = __webpack_public_path__ + "img/admin_apply01.aee66fb4.png";